import ScreenUtils from '../../../../shared/utils/screen';
import Selector from '../../atoms/images/menuSelector';
import { MenuSelectorProps as Props } from '../../../../shared/types/props/menu';

const ITEMS_OFFSET = 69;

function MenuSelector({ focused, index }: Props) {
  const animation = {
    opacity: focused ? 1 : 0,
    transform: `translateY(${
      ITEMS_OFFSET * Math.max(index || 0, 0) * ScreenUtils.widthRatio
    }px)`,
    transition: 'opacity 0.2s ease, transform 0.2s ease',
  };
  return (
    <>
      <Selector animation={animation} force={true} />
    </>
  );
}

export default MenuSelector;
